// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__JZuOI","inner":"Footer_inner__1U4cl","nextIcon":"Footer_nextIcon__1fAYn","innerLeft":"Footer_innerLeft__3TTGL"};